import {useContext} from 'react';

import TranscriptContext from '../../contexts/TranscriptContext';

const useTranscript = () => {
  return useContext(TranscriptContext);
};

export default useTranscript;
